import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fce4f98"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fce4f98')) {
      api.createRecord('1fce4f98', component.options)
    } else {
      api.reload('1fce4f98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fce4f98", function () {
      api.rerender('1fce4f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/screenshot/index.vue"
export default component.exports